var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.241,
    height: 14.102,
    viewBox: "0 0 29.241 14.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#211c51",
    d: "M29.194 145.493a.459.459 0 0 0-.613-.207 5.56 5.56 0 0 1-2.238.441h-2.517c-.092-.874-.341-3.005-.781-5.251-.785-4-1.79-6.463-2.989-7.308-1.558-1.1-2.9-.513-3.973-.042a3.985 3.985 0 0 1-1.462.445 3.985 3.985 0 0 1-1.462-.445c-1.076-.471-2.415-1.057-3.973.042-1.2.845-2.2 3.3-2.989 7.308-.44 2.246-.689 4.377-.781 5.251H2.9a5.56 5.56 0 0 1-2.237-.44.458.458 0 0 0-.409.819 6.365 6.365 0 0 0 2.647.537h23.441a6.365 6.365 0 0 0 2.647-.537.457.457 0 0 0 .205-.613zm-19.48-11.578c1.136-.8 2.036-.407 3.078.048a4.678 4.678 0 0 0 1.829.522 4.678 4.678 0 0 0 1.829-.522c1.042-.456 1.942-.85 3.078-.048 1.457 1.027 2.451 5.4 2.994 8.881H6.72c.543-3.476 1.538-7.854 2.994-8.881zm-3.379 11.812c.059-.568.142-1.257.248-2.015h16.076c.107.758.189 1.446.248 2.015z",
    transform: "translate(0 0) translate(0 0) translate(0 -132.541)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat);
export default __webpack_public_path__ + "static/media/hat.9b58ae5a.svg";
export { ForwardRef as ReactComponent };